import {
    negativeTicketPopUpDonateEmailText,
    negativeTicketPopUpEmailUseText,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

export default function(): JSX.Element {
    return (
        <div>
            <div>{loc(negativeTicketPopUpDonateEmailText)}</div>
            <br />
            <div>{loc(negativeTicketPopUpEmailUseText)}</div>
        </div>
    );
}
